import { render, staticRenderFns } from "./BannerRow.vue?vue&type=template&id=4264731b&scoped=true"
import script from "./BannerRow.vue?vue&type=script&lang=js"
export * from "./BannerRow.vue?vue&type=script&lang=js"
import style0 from "./BannerRow.vue?vue&type=style&index=0&id=4264731b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264731b",
  null
  
)

export default component.exports